import React from 'react';
import ProfileIcon from "../../../images/profile-icon.svg";
import MailIcon from "../../../images/mail-icon.svg";
import CallIcon from "../../../images/call-icon-2.png";
import RelationIcon from "../../../images/relation-icon.png";
import AddIcon from "../../../images/address-icon.png";
import DeathIcon from "../../../images/death-icon.png";
import { formatPhoneNumber } from '../../../utils/phoneFormatter';

interface LegacyContactTabProps {
  userData: any;
}

const LegacyContactTab: React.FC<LegacyContactTabProps> = ({ userData }) => {
  // Phone number formatting function is now imported from utils

  // Capitalize text helper
  const capitalizeText = (text: string) => {
    if (!text) return '';
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Format full address in US format
  const formatAddress = (contact: any) => {
    if (!contact) return 'Not provided';

    // US Address Format: address1, address2 (if exists), city, state zip
    const addressLine1 = contact.address1 || '';
    const addressLine2 = contact.address2 || '';
    const city = contact.city || '';
    const state = contact.state || '';
    const zip = contact.zip || '';

    // Build address parts
    const parts = [];

    // Add address lines
    if (addressLine1) {
      if (addressLine2) {
        parts.push(`${addressLine1}, ${addressLine2}`);
      } else {
        parts.push(addressLine1);
      }
    }

    // Add city, state zip on new line
    const cityStateZip = [];
    if (city) cityStateZip.push(city);
    if (state && zip) {
      cityStateZip.push(`${state} ${zip}`);
    } else if (state) {
      cityStateZip.push(state);
    } else if (zip) {
      cityStateZip.push(zip);
    }

    if (cityStateZip.length > 0) {
      parts.push(cityStateZip.join(', '));
    }

    return parts.length > 0 ? parts.join(', ') : 'Not provided';
  };

  // Check if primary contact has actual data (not just empty object)
  const hasPrimary = userData?.primaryLegacyContact &&
    Object.keys(userData.primaryLegacyContact).length > 0 &&
    (userData.primaryLegacyContact.name ||
     userData.primaryLegacyContact.email ||
     userData.primaryLegacyContact.phoneNumber);

  // Check if secondary contact has actual data (not just empty object)
  const hasSecondary = userData?.secondaryLegacyContact &&
    Object.keys(userData.secondaryLegacyContact).length > 0 &&
    (userData.secondaryLegacyContact.name ||
     userData.secondaryLegacyContact.email ||
     userData.secondaryLegacyContact.phoneNumber);

  console.log('=== LEGACY CONTACT DEBUG ===');
  console.log('userData:', userData);
  console.log('primaryLegacyContact:', userData?.primaryLegacyContact);
  console.log('secondaryLegacyContact:', userData?.secondaryLegacyContact);
  console.log('hasPrimary:', hasPrimary);
  console.log('hasSecondary:', hasSecondary);

  return (
    <div className="tab-pane-content legacy-tab">
      {/* Primary Legacy Contact - Only show if exists */}
      {hasPrimary && (
        <div className='billing-list'>
          <h3>Primary Legacy Contact</h3>
          <div className='row'>
            <ul>
              <li>
                <span>
                  <img src={ProfileIcon} alt='Profile' />
                </span>
                <p>Name: <strong>{capitalizeText(userData.primaryLegacyContact.name) || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={CallIcon} alt='Call' />
                </span>
                <p>Phone: <strong>{formatPhoneNumber(userData.primaryLegacyContact.phoneNumber) || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={MailIcon} alt='Mail' />
                </span>
                <p>Email: <strong>{userData.primaryLegacyContact.email || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={RelationIcon} alt='Relation' />
                </span>
                <p>Relationship: <strong>{capitalizeText(userData?.primaryLegacyContact?.relationship) || 'Not provided'}</strong></p>
              </li>
              {/* <li>
                <span>
                  <img src={DeathIcon} alt='Death' />
                </span>
                <p>Death Verification: <strong>SSN: *** ** ****</strong></p>
              </li> */}
              <li style={{ maxWidth: '300px' }}>
                <span>
                  <img src={AddIcon} alt='Address' />
                </span>
                <p style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                  Address: <strong>
                    {userData?.primaryLegacyContact?.address1 || userData?.primaryLegacyContact?.address2 ? (
                      <>
                        {userData.primaryLegacyContact.address1 && <>{userData.primaryLegacyContact.address1}<br /></>}
                        {userData.primaryLegacyContact.address2 && <>{userData.primaryLegacyContact.address2}<br /></>}
                        {(userData.primaryLegacyContact.city || userData.primaryLegacyContact.state || userData.primaryLegacyContact.zip) && (
                          <>
                            {userData.primaryLegacyContact.city && `${userData.primaryLegacyContact.city}, `}
                            {userData.primaryLegacyContact.state && `${userData.primaryLegacyContact.state} `}
                            {userData.primaryLegacyContact.zip}
                          </>
                        )}
                      </>
                    ) : 'Not provided'}
                  </strong>
                </p>
              </li>              
            </ul>
            {/* <ul className='col-xl-4 col-lg-6 col-md-6 col-md-12 mb-3'>
              <li>
                <span>
                  <img src={RelationIcon} alt='Relation' />
                </span>
                <p>Relationship: <strong>{userData.primaryLegacyContact.relationship || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={DeathIcon} alt='Death' />
                </span>
                <p>Death Verification: <strong>SSN: *** ** ****</strong></p>
              </li>
              <li>
                <span>
                  <img src={AddIcon} alt='Address' />
                </span>
                <p>Address: <strong>{userData.primaryLegacyContact.address || 'Not provided'}</strong></p>
              </li>
            </ul> */}
          </div>
        </div>
      )}
      
      {/* Secondary Legacy Contact - Only show if exists */}
      {hasSecondary && (
        <div className='billing-list'>
          <h3>Secondary Legacy Contact</h3>
          <div className='row'>
            <ul>
              <li>
                <span>
                  <img src={ProfileIcon} alt='Profile' />
                </span>
                <p>Name: <strong>{capitalizeText(userData.secondaryLegacyContact.name) || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={CallIcon} alt='Call' />
                </span>
                <p>Phone: <strong>{formatPhoneNumber(userData.secondaryLegacyContact.phoneNumber) || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={MailIcon} alt='Mail' />
                </span>
                <p>Email: <strong>{userData.secondaryLegacyContact.email || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={RelationIcon} alt='Relation' />
                </span>
                <p>Relationship: <strong>{capitalizeText(userData.secondaryLegacyContact.relationship) || 'Not provided'}</strong></p>
              </li>
              {/* <li>
                <span>
                  <img src={DeathIcon} alt='Death' />
                </span>
                <p>Death Verification: <strong>SSN: *** ** ****</strong></p>
              </li> */}
              <li style={{ maxWidth: '300px' }}>
                <span>
                  <img src={AddIcon} alt='Address' />
                </span>
                <p style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                  Address: <strong>
                    {userData?.secondaryLegacyContact?.address1 || userData?.secondaryLegacyContact?.address2 ? (
                      <>
                        {userData.secondaryLegacyContact.address1 && <>{userData.secondaryLegacyContact.address1}<br /></>}
                        {userData.secondaryLegacyContact.address2 && <>{userData.secondaryLegacyContact.address2}<br /></>}
                        {(userData.secondaryLegacyContact.city || userData.secondaryLegacyContact.state || userData.secondaryLegacyContact.zip) && (
                          <>
                            {userData.secondaryLegacyContact.city && `${userData.secondaryLegacyContact.city}, `}
                            {userData.secondaryLegacyContact.state && `${userData.secondaryLegacyContact.state} `}
                            {userData.secondaryLegacyContact.zip}
                          </>
                        )}
                      </>
                    ) : 'Not provided'}
                  </strong>
                </p>
              </li>
            </ul>
            {/* <ul className='col-xl-4 col-lg-6 col-md-6 col-md-12 mb-3'>
              <li>
                <span>
                  <img src={RelationIcon} alt='Relation' />
                </span>
                <p>Relationship: <strong>{userData?.secondaryLegacyContact?.relationship || 'Not provided'}</strong></p>
              </li>
              <li>
                <span>
                  <img src={DeathIcon} alt='Death' />
                </span>
                <p>Death Verification: <strong>SSN: *** ** ****</strong></p>
              </li>
              <li>
                <span>
                  <img src={AddIcon} alt='Address' />
                </span>
                <p>Address: <strong>{userData?.secondaryLegacyContact?.address || 'Not provided'}</strong></p>
              </li>
            </ul> */}
          </div>
        </div>
      )}

      {/* No contacts message - Only show if neither exists */}
      {!hasPrimary && !hasSecondary && (
        <div className='billing-list'>
          <div className="text-center py-4">
            <p>No legacy contact information available</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegacyContactTab;